import { TProps } from './types/TProps';
import { cn } from '@helpers/cn';

export const Block = ({ title, description, children, className = 'block-component' }: TProps) => {
  return (
    <div
      className={cn("relative flex min-w-0 flex-col md:flex-row pb-2.5 font-['General_Sans',sans-serif]", className)}
    >
      <div className="leftSide w-full md:max-w-[260px] shrink-0 grow-0 basis-auto md:pr-[30px]">
        <div className="title py-[5px] pb-2.5 text-xs font-semibold leading-[18px] text-[var(--color-text-muted)]">
          {title}
        </div>
        {description ? (
          <div className="description pb-2.5 text-xs font-normal leading-4 text-[var(--color-text-subtle)] [&_p]:mb-3">
            {description}
          </div>
        ) : null}
      </div>
      <div className="rightSide min-w-0 w-full [&>*]:mb-2.5">{children}</div>
    </div>
  );
};
